import { isArray } from "lodash-es";
import React, { FC } from "react";

import { IHttpRequestConfig } from "@/browser";
import { ISelectProps, Select } from "@/components/Select";
import { Text } from "@/components/Text";
import { formatFullName } from "@/data/persons";
import { fetchUsersList, IFetchUsersListParams, IUser } from "@/data/users";
import { codelistFactory, ICodelistFactoryProps as ICodelistProps, ReactSelectComponents } from "@/eworkitComponents";

export interface IUsersSelectProps
  extends ICodelistProps<Omit<ISelectProps, "simpleValue">, Partial<IUser>, IFetchUsersListParams> {}

const fetchUsers = async (params: IFetchUsersListParams, options: IHttpRequestConfig): Promise<IUser[]> => {
  const result = await fetchUsersList({ ...params }, options);

  return isArray<IUser>(result) ? result : result.content;
};

const CodelistUsersComponent = codelistFactory<ISelectProps, Partial<IUser>, IFetchUsersListParams>(fetchUsers, Select);

const UsersSelectComponent: FC<IUsersSelectProps> = ({ value, ...props }) => {
  const p = {
    ...props,
    portalPlacement: "auto",
  };

  return (
    <CodelistUsersComponent
      components={{
        MultiValueLabel: ({ children, ...restProps }) => {
          return (
            <ReactSelectComponents.MultiValueLabel {...restProps}>
              {formatFullName(restProps)}
            </ReactSelectComponents.MultiValueLabel>
          );
        },
        SingleValue: ({ children, ...restProps }) => {
          return (
            <ReactSelectComponents.SingleValue {...restProps}>
              <Text size={restProps.selectProps.size}>{formatFullName(restProps.data)}</Text>
            </ReactSelectComponents.SingleValue>
          );
        },
      }}
      labelKey={formatFullName}
      valueKey="id"
      simpleValue={false}
      {...p}
    />
  );
};

export const UsersSelect = React.memo(UsersSelectComponent);
